<template>
  <div v-if="loadingUser" class="my-16 py-16 d-flex justify-center">
    <v-progress-circular color="#0099ff" indeterminate/>
  </div>
  <div v-else class="pb-10">
    <v-card class="mb-5 mt-3 mx-3 pa-4" style="background-color: white;">
      <v-form
          class="w-100"
          @submit.prevent.stop="save"
      >
        <v-row>
          <v-col class="mb-3" cols="12" md="3">
            <v-select
                v-model="form.customer"
                :items="['Privat','Gewerblich']"
                autocomplete="on"
                color="#0099ff"
                density="comfortable"
                hide-details
                label="Kunde"
                type="text"
                variant="outlined"
            />
          </v-col>
          <v-col v-if="form.customer !== 'Gewerblich'" cols="0" md="9" class="pa-0"/>
          <v-col v-if="form.customer === 'Gewerblich'" class="mb-3" cols="12" md="12">
            <v-text-field
                v-model="form.company"
                autocomplete="on"
                color="#0099ff"
                density="comfortable"
                hide-details
                clearable
                label="Firma"
                type="text"
                variant="outlined"
            />
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-col class="mb-3" cols="12" md="3">
              <v-select
                  v-model="form.title"
                  :items="['Frau', 'Herr', 'Divers']"
                  autocomplete="on"
                  color="#0099ff"
                  density="comfortable"
                  hide-details
                  clearable
                  label="Anrede"
                  type="text"
                  variant="outlined"
              />
            </v-col>
          </v-col>
          <v-col class="mb-3" cols="12" md="6">
            <v-text-field
                v-model="form.firstname"
                autocomplete="on"
                color="#0099ff"
                density="comfortable"
                hide-details
                clearable
                label="Vorname"
                type="text"
                variant="outlined"
            />
          </v-col>
          <v-col class="mb-3" cols="12" md="6">
            <v-text-field
                v-model="form.lastname"
                autocomplete="on"
                color="#0099ff"
                density="comfortable"
                hide-details
                clearable
                label="Nachname"
                type="text"
                variant="outlined"
            />
          </v-col>
          <v-col class="mb-3" cols="12">
            <v-text-field
                v-model="addressInput"
                color="#0099ff"
                density="comfortable"
                autocomplete="off"
                clearable
                hide-details
                label="Adresse"
                type="text"
                variant="outlined"
                :loading="addressLoading"
                :error-messages="addressError"
                @update:modelValue="handleAddressInput"
            />
            <v-card
                v-if="addressSuggestions.length"
                class="address-suggestions mt-3"
                elevation="8"
            >
              <v-list density="compact">
                <v-list-item
                    v-for="suggestion in addressSuggestions"
                    :key="suggestion.placeId"
                    @click="selectAddress(suggestion)"
                >
                  <v-list-item-title>
                    <i class="fa-solid fa-location-dot ml-1 mr-2"/>{{ suggestion.label }}
                  </v-list-item-title>
                </v-list-item>
                <OsmAttribution/>
              </v-list>
            </v-card>
          </v-col>
          <v-col class="mb-3" cols="12" sm="6">
            <v-text-field
                v-model="form.phone"
                autocomplete="on"
                color="#0099ff"
                density="comfortable"
                hide-details
                clearable
                label="Telefon"
                type="text"
                variant="outlined"
            />
          </v-col>
          <v-col class="mb-3" cols="12" sm="6">
            <v-text-field
                v-model="form.email"
                :rules="[rules.email]"
                autocomplete="on"
                color="#0099ff"
                density="comfortable"
                hide-details
                readonly
                label="E-Mail"
                type="text"
                variant="outlined"
            />
          </v-col>
          <v-col class="d-flex justify-end" cols="12">
            <v-btn
                block
                class="btn-primary animation"
                type="submit">
              <i class="fa-regular fa-floppy-disk mr-2"/>
              Speichern
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {searchPhotonAddresses} from "@/services/photonAddress";
import OsmAttribution from "@/components/legal/OsmAttribution";

export default {
  name: "AccountDetails",
  components: {
    OsmAttribution
  },
  data() {
    return {
      form: {
        customer: '',
        title: '',
        company: '',
        firstname: '',
        lastname: '',
        street: '',
        house: '',
        zip: '',
        place: '',
        phone: '',
        email: ''
      },
      addressInput: '',
      selectedAddress: null,
      addressSuggestions: [],
      addressLoading: false,
      addressSearchTimeout: null,
      addressError: '',
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Die E-Mail ist ungültig.'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'loadingUser',
      'user'
    ])
  },
  methods: {
    updateFields() {
      this.form.customer = this.user.customer;
      this.form.company = this.user.company;
      this.form.title = this.user.title;
      this.form.firstname = this.user.firstname;
      this.form.lastname = this.user.lastname;
      this.form.street = this.user.street;
      this.form.house = this.user.house;
      this.form.zip = this.user.zip;
      this.form.place = this.user.place;
      this.form.phone = this.user.phone;
      this.form.email = this.user.email;
      this.addressInput = this.formatStoredAddress();
      this.selectedAddress = this.addressInput
          ? {
            label: this.addressInput,
            street: this.form.street,
            house: this.form.house,
            zip: this.form.zip,
            place: this.form.place
          }
          : null;
    },
    save() {
      if (!this.selectedAddress || this.selectedAddress.label !== this.addressInput) {
        this.addressError = 'Bitte wählen Sie eine eindeutige Adresse aus den Vorschlägen aus.';
        return;
      }

      this.$store.dispatch('updateUser', {
        customer: this.form.customer,
        company: this.form.company,
        title: this.form.title,
        firstname: this.form.firstname,
        lastname: this.form.lastname,
        street: this.form.street,
        house: this.form.house,
        zip: this.form.zip,
        place: this.form.place,
        phone: this.form.phone,
        email: this.form.email
      });
    },
    handleAddressInput(value) {
      this.selectedAddress = null;
      this.addressError = '';
      clearTimeout(this.addressSearchTimeout);

      if (!value || value.trim().length < 3) {
        this.addressSuggestions = [];
        return;
      }

      this.addressSearchTimeout = setTimeout(() => {
        this.fetchAddressSuggestions(value);
      }, 350);
    },
    async fetchAddressSuggestions(value) {
      this.addressLoading = true;

      try {
        const results = await searchPhotonAddresses(value);
        this.addressSuggestions = results
            .filter(item => this.isCompleteAddress(item))
            .map(item => ({
              placeId: item.place_id,
              label: this.formatAddress(item),
              street: this.getAddressStreet(item.address),
              house: item.address?.house_number || '',
              zip: item.address?.postcode || '',
              place: this.getAddressCity(item.address)
            }));
      } catch (error) {
        this.addressSuggestions = [];
      } finally {
        this.addressLoading = false;
      }
    },
    selectAddress(suggestion) {
      this.selectedAddress = suggestion;
      this.addressInput = suggestion.label;
      this.addressSuggestions = [];
      this.form.street = suggestion.street;
      this.form.house = suggestion.house;
      this.form.zip = suggestion.zip;
      this.form.place = suggestion.place;
    },
    getAddressStreet(address = {}) {
      return address.road || address.pedestrian || address.footway || address.residential || address.path || '';
    },
    getAddressCity(address = {}) {
      return address.city || address.town || address.village || address.municipality || '';
    },
    isCompleteAddress(item) {
      const address = item?.address || {};

      return !!(
          this.getAddressStreet(address) &&
          address.house_number &&
          this.getAddressCity(address) &&
          address.postcode
      );
    },
    formatAddress(item) {
      const address = item?.address || {};
      const streetWithHouse = `${this.getAddressStreet(address)} ${address.house_number}`.trim();

      return [
        streetWithHouse,
        [address.postcode, this.getAddressCity(address)].filter(Boolean).join(' '),
        address.country || 'Deutschland'
      ].filter(Boolean).join(', ');
    },
    formatStoredAddress() {
      if (!this.form.street || !this.form.house || !this.form.zip || !this.form.place) {
        return '';
      }

      return `${this.form.street} ${this.form.house}, ${this.form.zip} ${this.form.place}, Deutschland`;
    }
  },
  created() {
    this.updateFields();
  }
}
</script>
